import axiosClient from '../axiosClient';
import type { AxiosRequestConfig } from 'axios';

export interface DataViewAuditEvent {
  eventType: string;
  rowId: number;
  changeDate: string;
  userName: string;
  columnName?: string | null;
  oldValue?: string | null;
  newValue?: string | null;
  rowData?: Record<string, unknown> | null;
}

export async function getRowAudit (
  tableKey: string,
  rowId: number,
  signal?: AbortSignal
): Promise<DataViewAuditEvent[]> {
  const normalizedTableKey = String(tableKey || '').trim();
  if (!normalizedTableKey) {
    throw new Error('tableKey mangler');
  }
  const config: AxiosRequestConfig = {
    signal,
    params: { tableKey: normalizedTableKey, rowId }
  };
  const response = await axiosClient.get<DataViewAuditEvent[]>(
    'data-views/audit/row',
    config
  );
  return response.data ?? [];
}

export async function getDistinctAuditUsers (
  tableKey: string,
  signal?: AbortSignal
): Promise<string[]> {
  const normalizedTableKey = String(tableKey || '').trim();
  if (!normalizedTableKey) {
    throw new Error('tableKey mangler');
  }
  const config: AxiosRequestConfig = {
    signal,
    params: { tableKey: normalizedTableKey }
  };
  const response = await axiosClient.get<string[]>(
    'data-views/audit/distinct-users',
    config
  );
  return response.data ?? [];
}
